// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__YBiwo","opciones":"Menu_opciones__y2K+l","perfil":"Menu_perfil__MsqhG","foto":"Menu_foto__hcJPi"};